import { toDisplayString as _toDisplayString, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d19ae70")

_pushScopeId("data-v-0d19ae70")
const _hoisted_1 = { class: "pop-up pop-up-overlay" }
const _hoisted_2 = { class: "pop-up-content" }
const _hoisted_3 = { class: "pop-up-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "pop-up" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1),
          _createVNode("button", {
            class: "pop-up-close-button",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _toDisplayString(_ctx.buttonText), 1)
        ])
      ])
    ]),
    _: 1
  }))
})